const _enquiryCreated = enquiryId => ({
  event: 'EEnquiryID',
  dlWGEnquiryID: enquiryId
});

const _buyerSentFirstMessageToDealer = {
  event: 'WGFirstMessage'
};

const _motorwayClick = {
  event: 'valuations.WGMotorwayClick',
  eventData: {
    category: 'Valuations',
    action: 'Motorway Click',
    label: 'Get a free valuation 3'
  }
};

const _selectMake = make => ({
  event: 'valuations.WGSelectProspectiveMake',
  eventData: {
    category: 'Valuations',
    action: 'Select make',
    label: make
  }
});

const _selectModel = model => ({
  event: 'valuations.WGSelectProspectiveModel',
  eventData: {
    category: 'Valuations',
    action: 'Select model',
    label: model
  }
});

const _inputAttempt = fieldName => {
  return {
    event: 'valuations.WGInputAttempt',
    eventData: {
      category: 'Valuations',
      action: 'Step 2',
      label: `${fieldName} Attempts`
    }
  };
};

const _zutoOptInResult = (isOptedIn, make, model) => ({
  event: 'valuations.WGZutoOptIn',
  eventData: {
    category: 'Valuations',
    action: 'Step 2',
    label: `Zuto opt in ${isOptedIn ? 'yes' : 'no'}. ${make}${
      isOptedIn ? '/' : ''
    }${model}`
  }
});

const _oemOptInResult = (isOptedIn, make, model) => ({
  event: 'valuations.WGOEMOptIn',
  eventData: {
    category: 'Valuations',
    action: 'Step 2',
    label: `OEM opt in ${isOptedIn ? 'yes' : 'no'}. ${make}${
      isOptedIn ? '/' : ''
    }${model}`
  }
});

const _campaignPopup = make => ({
  event: 'valuations.WGOEMPopUp',
  eventData: {
    category: 'Valuations',
    action: 'LeadGen',
    label: make
  }
});

const _zutoPopup = {
  event: 'zutoOEMPopUp'
};

const _vitalityPopup = {
  event: 'vitalityOEMPopUp'
};

export default {
  enquiryCreated: _enquiryCreated,
  buyerSentFirstMessageToDealer: _buyerSentFirstMessageToDealer,
  motorwayClick: _motorwayClick,
  selectMake: _selectMake,
  selectModel: _selectModel,
  inputAttempt: _inputAttempt,
  zutoOptInResult: _zutoOptInResult,
  oemOptInResult: _oemOptInResult,
  campaignPopup: _campaignPopup,
  zutoPopup: _zutoPopup,
  vitalityPopup: _vitalityPopup
};



// WEBPACK FOOTER //
// ./src/utils/ga/events/customDimensions.js